import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { MessageBanner } from '@folio/stripes/components';
import useUserNames from '../../hooks/useUserNames';
import useOrganizationNames from '../../hooks/useOrganizationNames';
var AUTHORITIES_PATH = '/czna-authorities/authorities';
/**
 * CZNA-1476 — amendments of this authority that are still in progress, at the top of its
 * detail. An amendment used to be visible only in its author's drafts, so it read as a second,
 * unrelated record, nothing led to it from the authority, and another library could start a
 * second amendment of the same authority unaware of the first.
 *
 * <p>Shown to every viewer whatever their library — that is the point. Renders nothing when
 * there is no open amendment, so such a detail looks exactly as before.
 *
 * <p>The link opens the proposal inside the authorities section (`/authorities/proposals/:id`,
 * CZNA-1190), next to the same result list, rather than in a workspace chosen by status: a
 * draft of another library has no place in "Moje koncepty".
 */
var OpenProposalsList = function (_a) {
    var items = _a.items;
    var intl = useIntl();
    var getUserName = useUserNames(items.map(function (p) { return p.createdBy; })).getUserName;
    var _b = useOrganizationNames(), getOrganizationSigla = _b.getOrganizationSigla, getOrganizationName = _b.getOrganizationName;
    var author = function (proposal) {
        var _a, _b;
        var name = (_a = getUserName(proposal.createdBy)) !== null && _a !== void 0 ? _a : proposal.createdBy;
        var library = (_b = getOrganizationSigla(proposal.organizationId)) !== null && _b !== void 0 ? _b : getOrganizationName(proposal.organizationId);
        return [name, library].filter(Boolean).join(' / ');
    };
    return (React.createElement(MessageBanner, { type: "warning" },
        React.createElement("div", { "data-testid": "record-open-proposals" },
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.openProposals.title", values: { count: items.length } })),
            React.createElement("ul", null, items.map(function (proposal) { return (React.createElement("li", { key: proposal.id, "data-testid": "record-open-proposal-".concat(proposal.id) },
                React.createElement(Link, { to: "".concat(AUTHORITIES_PATH, "/proposals/").concat(proposal.id) }, proposal.authorityId),
                ' — ',
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.proposalStatus.".concat(proposal.status) }),
                ' · ',
                author(proposal),
                ' · ',
                intl.formatDate(proposal.createdAt, { day: 'numeric', month: 'numeric', year: 'numeric' }))); })))));
};
// The name lookups live in OpenProposalsList so a detail without an open amendment — the
// usual case — mounts none of them and fetches nothing extra.
var OpenProposalsBanner = function (_a) {
    var proposals = _a.proposals;
    return (proposals && proposals.length > 0 ? React.createElement(OpenProposalsList, { items: proposals }) : null);
};
export default OpenProposalsBanner;
